<template>
    <div class="print-component-outside">
        <div class="print-component" v-click-outside="closeDialog">
            <h2>Print {{ name }}</h2>
            <!-- <v-switch
                    class="nav-bar-switch"
                    v-model="lightTheme"
                    :label="$t('NavBar.Header.NavBarSwitch.Switch-Theme')">
                  </v-switch> -->
            <StandardSwitch v-for="setting in getSettings" :key="`${setting.desc.toLowerCase()} setting`" class="my-2" :value="setting.value" @changeValue="changeValue(setting.key, setting.desc, setting.localStorage)" :label="setting.desc" />
            <div v-if="name === 'Taktplan'" style="font-size: 14px">When printing on paper we recommend to use the light theme</div>
            <div class="print-component-action-container">
                <div class="print-component-action elevation-10" @click="print('jpeg')">
                    <v-progress-circular v-if="loading === 'jpeg'" :size="60" indeterminate :width="5" class="mb-1" />
                    <v-icon v-else size="80">image</v-icon>
                    <div>download as .jpeg</div>
                </div>
                <div class="print-component-action elevation-10" @click="print('pdf')">
                    <v-progress-circular v-if="loading === 'pdf'" :size="60" indeterminate :width="5" class="mb-1" />
                    <v-icon v-else size="80">description</v-icon>
                    <div>download as .pdf</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue'

import { jsPDF } from "jspdf";

export default {
    props: [
        'name',
        'print_el',
        'height_el',
        'width_el',
        'file_name',
        'legend_el',
    ],
    components: {
        StandardSwitch
    },
    data: () => ({
        lightTheme: false,
        loading: false,
    }),
    computed: {
        getSettings() {
            let settings = [];

            if (this.name === 'Taktplan' || this.name === 'Wallet') {
                settings.push({
                    desc: 'Light Theme',
                    localStorage: 'Light_Theme',
                    value: !this.$vuetify.theme.dark,
                    key: 'theme',
                });
            }

            if (this.name === 'WalletPrint') {
                settings.push({
                    desc: 'Background Color',
                    localStorage: 'Background_Color',
                    value: this.$store.state.View.is_print_background_color,
                    key: 'is_print_background_color',
                }, {
                    desc: 'Print Worksteps',
                    localStorage: 'Print_Worksteps',
                    value: this.$store.state.View.is_print_worksteps,
                    key: 'is_print_worksteps',
                }, {
                    desc: 'Print Manpower',
                    localStorage: 'Print_Manpower',
                    value: this.$store.state.View.is_print_manpower,
                    key: 'is_print_manpower',
                }, {
                    desc: 'Print Cutting Line',
                    localStorage: 'Print_Cutting_Line',
                    value: this.$store.state.View.is_print_cutting_line,
                    key: 'is_print_cutting_line',
                });
            }

            if (this.name === 'Taktplan') {
                settings.push({
                    desc: 'Taktplan Grid Column',
                    localStorage: 'Taktplan_Grid_Column',
                    value: this.$store.state.View.is_taktplan_grid_column,
                    key: 'is_taktplan_grid_column',
                }, {
                    desc: 'Taktplan Grid Row',
                    localStorage: 'Taktplan_Grid_Row',
                    value: this.$store.state.View.is_taktplan_grid_row,
                    key: 'is_taktplan_grid_row',
                }, {
                    desc: 'Takt Time Highlight',
                    localStorage: 'Takt_Time_Highlight',
                    value: this.$store.state.View.is_taktplan_takttime_highlight,
                    key: 'is_taktplan_takttime_highlight',
                }, {
                    desc: 'Milestone Highlight',
                    localStorage: 'Milestone_Highlight',
                    value: this.$store.state.View.is_taktplan_milestone_highlight,
                    key: 'is_taktplan_milestone_highlight',
                }, {
                    desc: 'Train Seperator',
                    localStorage: 'Train_Seperator',
                    value: this.$store.state.View.is_taktplan_train_seperator,
                    key: 'is_taktplan_train_seperator',
                }, {
                    desc: 'Taktplan Legend',
                    localStorage: 'Taktplan_Legend',
                    value: this.$store.state.View.is_taktplan_legend,
                    key: 'is_taktplan_legend',
                }, {
                    desc: 'Taktplan Legend Left',
                    localStorage: 'Taktplan_Legend_Left',
                    value: this.$store.state.View.is_taktplan_legend_left,
                    key: 'is_taktplan_legend_left',
                }, {
                    desc: 'Taktplan Legend Left Rotated',
                    localStorage: 'Taktplan_Legend_Left_Rotated',
                    value: this.$store.state.View.is_taktplan_legend_left_rotated,
                    key: 'is_taktplan_legend_left_rotated',
                },
                {
                    desc: 'Taktplan Legend Milestones',
                    localStorage: 'Is_Taktplan_Legend_Milestones',
                    value: this.$store.state.View.is_taktplan_legend_milestones,
                    key: 'is_taktplan_legend_milestones',
                },
                {
                    desc: 'Taktplan Taktarea Description',
                    localStorage: 'Taktplan_Taktarea_Description',
                    value: this.$store.state.View.is_taktplan_taktarea_description,
                    key: 'is_taktplan_taktarea_description',
                },
                {
                    desc: 'Show Shadows in Taktplan',
                    localStorage: 'Taktplan_Shadows',
                    value: this.$store.state.View.show_taktplan_shadows,
                    key: 'show_taktplan_shadows',
                },
                {
                    desc: 'Show Taktplan',
                    localStorage: 'Show_Taktplan',
                    value: this.$store.state.View.show_taktplan,
                    key: 'show_taktplan',
                },
                {
                    desc: 'Timestamp',
                    localStorage: 'Taktplan_Timestamp',
                    value: this.$store.state.View.is_taktplan_timestamp,
                    key: 'is_taktplan_timestamp',
                },
                )
            }
            return settings;
        }
    },
    mounted() {
        let self = this;
        Vue.nextTick(function() {
            self.setValue({ key: 'is_printing_mode_loading', value: false })
        })

    },
    methods: {
        ...mapActions('View', [
            'setValue',
        ]),
        closeDialog() {
            this.setValue({ key: 'is_printing_mode', value: false })
        },
        changeTheme() {
            localStorage.setItem('TAKT_theme', !this.$vuetify.theme.dark);
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark
        },
        changeValue(variable, desc, storageKey) {
            // NOTE: is handled in $vuetify
            if (variable === 'theme') {
                this.changeTheme();
            }
            // NOTE: everything elese is handled in $store.state.View
            else {
                // cookie strings are: 'Taktplan_Grid', 'Takt_Time_Highlight', 'Train_Seperator', 'Taktplan_Legend'
                localStorage.setItem(storageKey, !this.$store.state.View[variable]);
                this.setValue({ key: variable, value: !this.$store.state.View[variable] });
            }
        },
        print(format) {
            this.loading = format;
            let self = this;
            let print_el = document.getElementById(this.print_el);

            let height = document.getElementById(this.height_el).clientHeight;

            const actual_width_el = document.getElementById(this.width_el);
            let width = 1440;
            if (actual_width_el) {
                width = actual_width_el.clientWidth;
            }

            let legend = document.getElementById(this.legend_el);
            if (legend) {
                if (this.$store.state.View.is_taktplan_legend_left) {

                    let legend_left = document.getElementById('legend-container-left');
                    if (this.$store.state.View.is_taktplan_legend_left_rotated) {
                        // height = Math.max(height, legend_left.clientHeight);
                        height = height + legend_left.clientHeight;
                    }

                    if (legend_left.clientWidth > width) {
                        width = legend_left.clientWidth;
                    }
                } else {
                    height = Math.max(height, legend.clientHeight);
                    width += legend.clientWidth;
                }
            }

            let bgcolor;
            if (this.$vuetify.theme.dark) {
                bgcolor = 'black';
            } else {
                bgcolor = 'white';
            }
            setTimeout(function() {
                // to jpeg
                // weird hack to get the correct width and height for the pdf, that bottom is not cut off
                if (height > width) {
                    width = height;
                }
                self.$domToImageMore.toJpeg(print_el, { quality: 1, height: height, width: width, bgcolor: bgcolor })
                    .then(function(dataUrl) {
                        if (format === 'jpeg') {
                            var link = document.createElement('a');
                            link.download = `${self.name}-${self.file_name}.jpeg`;
                            link.href = dataUrl;
                            link.click();
                        } else if (format === 'pdf') {
                            let image = new Image();
                            image.src = dataUrl;
                            let orientation = 'landscape';
                            if (self.name === 'WalletPrint') {
                                orientation = 'portrait';
                            }
                            let pdf = new jsPDF({ orientation: orientation, unit: 'px', format: [width, height], hotfixes: ["px_scaling"] });
                            pdf.addImage({imageData: image, format: 'JPEG'})
                            // Get the current date components
                            let today = new Date();
                            let year = today.getFullYear();
                            let month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
                            let day = today.getDate().toString().padStart(2, '0');
                            let hours = today.getHours().toString().padStart(2, '0');
                            let minutes = today.getMinutes().toString().padStart(2, '0');

                            // Create the formatted date-time string
                            var formattedDateTime = year + month + day + '_' + hours + minutes;

                            pdf.save(formattedDateTime + `_Taktplan-${self.file_name}.pdf`);
                        }
                        self.loading = false;
                    });
            }, 1000);
        }
    }
}
</script>

<style>
.print-component-outside {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 200;
}

.print-component {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 400px;
    /* height: 300px; */
    transform: translate(-50%, -50%);
    background-color: var(--v-color-3-base);
    z-index: 100;
    border-radius: 10px;
    padding: 10px;
}

.print-component-action-container {
    display: flex;
    justify-content: space-around;
}

.print-component-action {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 130px;
    height: 130px;
    border-radius: 6px;
    border: 1px solid white;
    margin: 20px 5px 20px 5px;
    font-size: 14px;
    cursor: pointer;
}
</style>
